import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isError, isRequest } from '../utils/is.js';
import { fill, addNonEnumerableProperty } from '../utils/object.js';
import { supportsNativeFetch } from '../utils/supports.js';
import { timestampInSeconds } from '../utils/time.js';
import { GLOBAL_OBJ } from '../utils/worldwide.js';
import { addHandler, maybeInstrument, triggerHandlers } from './handlers.js';

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
  var type = 'fetch';
  addHandler(type, handler);
  maybeInstrument(type, function () {
    return instrumentFetch(undefined, skipNativeFetchCheck);
  });
}

/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */
function addFetchEndInstrumentationHandler(handler) {
  var type = 'fetch-body-resolved';
  addHandler(type, handler);
  maybeInstrument(type, function () {
    return instrumentFetch(streamHandler);
  });
}
function instrumentFetch(onFetchResolved) {
  var skipNativeFetchCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (skipNativeFetchCheck && !supportsNativeFetch()) {
    return;
  }
  fill(GLOBAL_OBJ, 'fetch', function (originalFetch) {
    return function () {
      // We capture the error right here and not in the Promise error callback because Safari (and probably other
      // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.

      // NOTE: If you are a Sentry user, and you are seeing this stack frame,
      //       it means the error, that was caused by your fetch call did not
      //       have a stack trace, so the SDK backfilled the stack trace so
      //       you can see which fetch call failed.
      var virtualError = new Error();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var _parseFetchArgs = parseFetchArgs(args),
        method = _parseFetchArgs.method,
        url = _parseFetchArgs.url;
      var handlerData = {
        args: args,
        fetchData: {
          method: method,
          url: url
        },
        startTimestamp: timestampInSeconds() * 1000,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError: virtualError,
        headers: getHeadersFromFetchArgs(args)
      };

      // if there is no callback, fetch is instrumented directly
      if (!onFetchResolved) {
        triggerHandlers('fetch', _objectSpread({}, handlerData));
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(GLOBAL_OBJ, args).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (onFetchResolved) {
                  onFetchResolved(response);
                } else {
                  triggerHandlers('fetch', _objectSpread(_objectSpread({}, handlerData), {}, {
                    endTimestamp: timestampInSeconds() * 1000,
                    response: response
                  }));
                }
                return _context.abrupt("return", response);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), function (error) {
        triggerHandlers('fetch', _objectSpread(_objectSpread({}, handlerData), {}, {
          endTimestamp: timestampInSeconds() * 1000,
          error: error
        }));
        if (isError(error) && error.stack === undefined) {
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the error, that was caused by your fetch call did not
          //       have a stack trace, so the SDK backfilled the stack trace so
          //       you can see which fetch call failed.
          error.stack = virtualError.stack;
          addNonEnumerableProperty(error, 'framesToPop', 1);
        }

        // We enhance the not-so-helpful "Failed to fetch" error messages with the host
        // Possible messages we handle here:
        // * "Failed to fetch" (chromium)
        // * "Load failed" (webkit)
        // * "NetworkError when attempting to fetch resource." (firefox)
        if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) {
          try {
            var _url = new URL(handlerData.fetchData.url);
            error.message = "".concat(error.message, " (").concat(_url.host, ")");
          } catch (_unused) {
            // ignore it if errors happen here
          }
        }

        // NOTE: If you are a Sentry user, and you are seeing this stack frame,
        //       it means the sentry.javascript SDK caught an error invoking your application code.
        //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
        throw error;
      });
    };
  });
}
function resolveResponse(_x2, _x3) {
  return _resolveResponse.apply(this, arguments);
}
function _resolveResponse() {
  _resolveResponse = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res, onFinishedResolving) {
    var body, responseReader, maxFetchDurationTimeout, readingActive, chunkTimeout, _yield$responseReader, done;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(res !== null && res !== void 0 && res.body)) {
            _context2.next = 28;
            break;
          }
          body = res.body;
          responseReader = body.getReader(); // Define a maximum duration after which we just cancel
          maxFetchDurationTimeout = setTimeout(function () {
            body.cancel().then(null, function () {
              // noop
            });
          }, 90 * 1000 // 90s
          );
          readingActive = true;
        case 5:
          if (!readingActive) {
            _context2.next = 25;
            break;
          }
          chunkTimeout = void 0;
          _context2.prev = 7;
          // abort reading if read op takes more than 5s
          chunkTimeout = setTimeout(function () {
            body.cancel().then(null, function () {
              // noop on error
            });
          }, 5000);

          // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
          _context2.next = 11;
          return responseReader.read();
        case 11:
          _yield$responseReader = _context2.sent;
          done = _yield$responseReader.done;
          clearTimeout(chunkTimeout);
          if (done) {
            onFinishedResolving();
            readingActive = false;
          }
          _context2.next = 20;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](7);
          readingActive = false;
        case 20:
          _context2.prev = 20;
          clearTimeout(chunkTimeout);
          return _context2.finish(20);
        case 23:
          _context2.next = 5;
          break;
        case 25:
          clearTimeout(maxFetchDurationTimeout);
          responseReader.releaseLock();
          body.cancel().then(null, function () {
            // noop on error
          });
        case 28:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[7, 17, 20, 23]]);
  }));
  return _resolveResponse.apply(this, arguments);
}
function streamHandler(response) {
  // clone response for awaiting stream
  var clonedResponseForResolving;
  try {
    clonedResponseForResolving = response.clone();
  } catch (_unused2) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  resolveResponse(clonedResponseForResolving, function () {
    triggerHandlers('fetch-body-resolved', {
      endTimestamp: timestampInSeconds() * 1000,
      response: response
    });
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }
  if (!resource) {
    return '';
  }
  if (hasProp(resource, 'url')) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return {
      method: 'GET',
      url: ''
    };
  }
  if (fetchArgs.length === 2) {
    var _fetchArgs = _slicedToArray(fetchArgs, 2),
      url = _fetchArgs[0],
      options = _fetchArgs[1];
    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
    };
  }
  var arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
  };
}
function getHeadersFromFetchArgs(fetchArgs) {
  var _fetchArgs2 = _slicedToArray(fetchArgs, 2),
    requestArgument = _fetchArgs2[0],
    optionsArgument = _fetchArgs2[1];
  try {
    if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) {
      return new Headers(optionsArgument.headers);
    }
    if (isRequest(requestArgument)) {
      return new Headers(requestArgument.headers);
    }
  } catch (_unused3) {
    // noop
  }
  return;
}
export { addFetchEndInstrumentationHandler, addFetchInstrumentationHandler, parseFetchArgs };